module.exports = __webpack_public_path__ + "img/six-page-bg-en.49aecec9.png";